import type { FC } from "react";
import React from "react";

import { ButtonCellLeftIcon } from "../../../general/components/LeftIcon/ButtonCellLeftIcon";
import { createDisplayNameForButtonCellActionElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellActionElement } from "../../utils/getTestId";

import type { IButtonCellLeftIcon } from "../../../general/components/LeftIcon/ButtonCellLeftIcon";

const LEFT_ICON_TEST_ID = createTestIdForButtonCellActionElement("left-icon");

export const ButtonCellActionLeftIcon: FC<IButtonCellLeftIcon> = ({
    icon,
    "data-tsid": tsid,
}) => {
    const dataTestId = tsid || LEFT_ICON_TEST_ID;

    return <ButtonCellLeftIcon icon={icon} data-tsid={dataTestId} />;
};

ButtonCellActionLeftIcon.displayName =
    createDisplayNameForButtonCellActionElement("LeftIcon");

export default ButtonCellActionLeftIcon;
